import { IS_CLIENT, IS_ANDROID, IS_IOS } from '@repo/common-utils';

import { useCommonRouter } from '../components/RouterProvider';

import { useWorkingPlatform } from './use-working-platform';

export const useWindowOpen = () => {
  const router = useCommonRouter();
  const { workingPlatform, browserType, workingPlatformType } = useWorkingPlatform();

  const openWindow = (link: string, target?: string) => {
    if (!IS_CLIENT) return;

    if (browserType === 'webview') {
      const payload = JSON.stringify({ url: link });
      if (workingPlatform === 'kbank') {
        if (IS_ANDROID) {
          window?.kbw?.kbankopenbrowser?.(payload);
        } else if (IS_IOS) {
          window?.webkit?.messageHandlers?.kbankopenbrowser?.postMessage(payload);
        }
      } else if (workingPlatform === 'cashnote') {
        if (IS_ANDROID) {
          window?.CashnoteAndroidInterface?.openExternalBrowserLink?.(payload);
        } else if (IS_IOS) {
          window?.webkit?.messageHandlers?.openExternalBrowserLink?.postMessage(payload);
        }
      }
      return;
    }

    if (target === '_self') {
      const isExternal = link.startsWith('//') || /^[a-z][a-z0-9+.-]*:/i.test(link);
      if (isExternal) window.location.assign(link);
      else router.push(link);
      return;
    }
    window.open(link, target ?? (workingPlatformType === 'web' ? '_blank' : '_system'));
  };

  return {
    openWindow
  };
};
